<template>
  <div class="content" >
    <WebHeader menu='3' ></WebHeader>
    <div class="web-page">
      <div id="benImg" class="imgdiv">
        <img src="static/img/employeeStories/headerImage.jpg" >
      </div>

      <div class="block-title title">
        <div></div>
        <div>员工故事</div>
        <div></div>
      </div>
        <div class="detail" :class="index%2 ===0?'rowD': 'rowReverseD'" v-for="(item, index) in dataList">
          <div class="images" :id="index">

            <img :src="item.photo">
          </div>

          <div class="detection">

            <div>
              <div class="p1 xiahuaxian">  <span>{{item.title}}</span></div>
              <p class="p2">{{item.minTitle}}</p>
              <p class="p3">{{item.center}}</p>
            </div>
            <div>
              <p class="p4">{{item.endChinese}}</p>
              <p class="p5">{{item.endEnglish}}</p>
            </div>
          </div>
        </div>


    </div>
    <div class="footerHeight"></div>
    <top-button></top-button>
    <WebFooter></WebFooter>
 <!--   <WebLoading></WebLoading>-->
  </div>
</template>

<script>
  import { getList } from "@/api/product";
  import TopButton from "../../components/web/topButton";
 /* window.onload = function () {
    document.getElementById("pageLoading").remove();
  }*/
    export default {
        name: "CorporateCulture",
      components: {TopButton},
      data() {
        return {
          dataList: [
            {
              title: '打造国产MR产品生产新标杆',
              photo: require('../../../static/img/employeeStories/luzhenzhong1.jpg'),
              minTitle: 'Zhenzhong 毕业于天津大学',
              center: '立足天津，服务中国。带领团队打破产能瓶颈，优化生产工艺，提升质量水平，不断突破工厂极限，为中国用户更快，更多，更好地交付标杆级的MR产品。',
              endChinese: '共创无界的医疗关爱',
              endEnglish: 'Create a world where healthcare has no limits'
            },
            {
              title: '博观约取，精进不休，做有温度的工程师',
              photo: require('../../../static/img/employeeStories/sunxiaojun2.jpg'),
              minTitle: 'Allen 毕业于天津大学',
              center: '2020年通过SSEP项目加入GE医疗客户服务部，3年来不断强化学习，博采众长砥砺深耕，从技术小白快速地成长为独当一面的技术人才。践行“知所想、智所达”的服务理念，以客户为中心，急客户所急，帮客户所需，是一名有温度的工程师。',
              endChinese: '共创无界的医疗关爱',
              endEnglish: 'Create a world where healthcare has no limits'
            },
            {
              title: '用专业所学，想医患所想',
              photo: require('../../../static/img/employeeStories/wangxinyuan3.jpg'),
              minTitle: 'Steve 毕业于麻省大学阿默斯特分校',
              center: '作为公司新人，非常幸运地参加了核心项目。通过这个项目的锻炼和导师对我的耐心指导，我的沟通能力和专业技术都有了很大提升。目前我的第一个轮岗正在进行中，很开心可以通过自己的专业所学提供设备的安全保障，为患者减轻痛苦，为医生减少负担。',
              endChinese: '共创无界的医疗关爱',
              endEnglish: 'Create a world where healthcare has no limits'
            },
            {
              title: '用严谨解决问题，以热情追求创新',
              photo: require('../../../static/img/employeeStories/xiaojiahui4.png'),
              minTitle: 'Sophia 毕业于美国伊利诺伊大学香槟分校',
              center: '学生时代开始接触磁共振成像，不变的热情和积累的知识转换成了职场上的动力。从日常传统代码的集成，到深度学习等前沿算法的引进，在稳扎稳打的同时，不惧天马行空的畅想。',
              endChinese: '共创无界的医疗关爱',
              endEnglish: 'Create a world where healthcare has no limits'
            },{
              title: '以信息技术赋能，助力增长与高效运营',
              photo: require('../../../static/img/employeeStories/yangxiaotian5.png'),
              minTitle: 'Shirly 毕业于慕尼黑工业大学的机器人、智能与感知专业',
              center: '在两年的时间内经历了三个不同方向的轮岗丰富的轮岗经历使我能够快速拥抱变化，敏捷学习，并以信息技术、网络安全等多视角了解业务流程与数字化系统；并通过项目实践，用信息技术更好的助力GE医疗的业务增长以及高效运营。',
              endChinese: '共创无界的医疗关爱',
              endEnglish: 'Create a world where healthcare has no limits'
            },
            {
              title: '信息推动发展，竭力做好 “隐形支柱”',
              photo: require('../../../static/img/employeeStories/zhangjunyi6.jpg'),
              minTitle: 'Myc以身构筑桥梁，连接IT与业务，实现QRA部门在系统层面的合规要求与管控。主导或参与过项目为医疗器械唯一识别码（UDI）和Smart Installation Tool（SIT）等大型项目，推进GE医疗业务流程信息化、规范化，借科技之力协助落实国家法规。',
              center: '',
              endChinese: '共创无界的医疗关爱',
              endEnglish: 'Create a world where healthcare has no limits'
            },
            {
              title: '突破自我，推动改变',
              photo: require('../../../static/img/employeeStories/vivian7.jpg'),
              minTitle: 'Vivian 本科毕业于上海财经大学，MBA毕业于INSEAD',
              center: '从财务控制到战略分析，从产品管理到市场经理，一次次挑战新的岗位和全新领域，一路实现职业转型和自我突破，在极为挑战的商业环境下，传递中国市场的声音，有效推动了产品的管线发展。',
              endChinese: '共创无界的医疗关爱',
              endEnglish: 'Create a world where healthcare has no limits'
            },
            {
              title: 'MR 3D打印推动者',
              photo: require('../../../static/img/employeeStories/helongfei8.png'),
              minTitle: 'Manfred 毕业于帝国理工学院',
              center: '把3D 打印技术与工作相结合，直接带来了团队工作效率的提高和产品成本的降低。在公司的工程师文化周活动中，积极协助组委会设置“黑客马拉松3D打印”项目的赛制，并影响了MR部门成为3D打印竞赛参赛人数最多的部门。',
              endChinese: '共创无界的医疗关爱',
              endEnglish: 'Create a world where healthcare has no limits'
            }],
          queryParams: {
            pageNum: 1,
            pageSize: 20,
            httpType: 'yuangong'
          }

        }
      },
      methods: {
        getImgUrl(value){
          return this.global.apiHttpUrl+value;
        },
        slide(vales){
          document .getElementById(vales) .scrollIntoView({ behavior: 'smooth' })
        },
      },
      // created() {
      //   getList(this.queryParams).then(response => {
      //     console.log(response.data.rows);
      //     this.dataList=response.data.rows;
      //   });
      // },
      mounted() {
        let name = this.$route.query.name;
        if (name!=undefined){
          this.slide(name);
        }
      }
    }
</script>

<style scoped>
  .imgdiv{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .imgdiv img{
    width: 100%;
  }
  .padTo{
    padding-left: 60px;
  }
  .padNo{
    padding-left: 0px;
  }
  .rowD{
    flex-direction: row
  }
  .rowReverseD{
    flex-direction: row-reverse;
  }
  .title{
   text-align: center;
    margin-top: 50px;
    margin-bottom: 111px;

    line-height: 52px;
  }


  .detail {
    width: 1200px;
    margin:0px auto 75px auto;
    display: -webkit-flex; /* Safari */
    display: flex;
    justify-content:space-between;
  }

  .images img{
    width: 540px;
    height: 410px;
    object-fit: cover;
  }
  .p1Div{
    width: 100%;
    height: 8px;
    /*border-bottom: solid 10px #e1dbff;*/
  }
  .xiahuaxian{
    margin: 30px 0;
    line-height: 30px;
  }
  .xiahuaxian span{
    box-shadow: 0 -16px #EBE3FA inset,0 7px #EBE3FA;

  }

  .p1{

    font-size: 32px;
    font-weight: 600;
    color: #333333;
    line-height: 52px;
  /*  padding-bottom: 35px;*/
  }
  .p2{
    font-size: 22px;
    font-weight: 400;
    color: #666666;
    line-height: 36px;
    margin-top: 35px;
  }
  .p3{
    font-size: 22px;
    font-weight: 400;
    color: #666666;
    line-height: 36px;
    padding-bottom: 46px;
  }
  .p4{
    font-size: 26px;
    font-weight: 500;
    color: #272727;
    line-height: 52px;
  }
  .p5{

    font-size: 20px;
    font-weight: 500;
    color: #272727;
    line-height: 36px;

  }
  .detection{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 593px;
    overflow: hidden;
  }

  .footerHeight{
    height: 110px;
  }


  @media screen and (min-width: 1200px) and (max-width: 2000px){
    .xiahuaxian{
      margin: 5px 0;
      line-height: 32px;
    }
  }

  @media screen and (max-width: 1318px){
    .detail{
      display: flex;
      flex-direction: column;
      align-items: center;

    }
    .images{
      padding-left: 0px !important;
    }
    .detection{
      /*width: 540px;*/
      width: 67.51vw;
      padding-left: 0px !important;
    }

    .detail {
      width: 100%;
      margin:0px auto 60px auto;
    }

    .images img{
      width: 67.51vw;
      height: 51.24vw;
    }

    .xiahuaxian{
      margin: 32px 0 15px;
    }
    .p1{
      font-size: 24px;
      line-height: 30px;
    }
    .p2{
      font-size: 17px;
      margin-top: 15px;
    }
    .p3{
      font-size: 17px;
      padding-bottom: 20px;
    }
    .p4{
      font-size: 19px;

    }
    .p5{
      font-size: 14px;
    }

    }

</style>



// WEBPACK FOOTER //
// src/views/web/corporateCulture.vue